import React from "react";

const PaginationButtons = ({ currentPage, setCurrentPage, goToPage, pages, hasNextPage, fetchNextPage }) => {
  return (
    <div className="d-md-flex align-items-center dt-layout-end col-md-auto ms-auto d-flex gap-md-4 justify-content-md-between justify-content-center gap-2 flex-wrap">
      <div className="dt-paging">
        <nav aria-label="pagination">
          <ul className="pagination d-flex flex-wrap">
            <li className={`dt-paging-button page-item ${currentPage === 0 ? "disabled" : ""}`}>
              {" "}
              <button onClick={() => goToPage(0)} className="page-link first" role="link" tabIndex={-1}>
                <i className="icon-base ti tabler-chevrons-left scaleX-n1-rtl icon-18px" />
              </button>{" "}
            </li>
            <li className={`dt-paging-button page-item ${currentPage === 0 ? "disabled" : ""}`}>
              <button onClick={() => goToPage(currentPage - 1)} className="page-link previous" role="link" tabIndex={-1}>
                <i className="icon-base ti tabler-chevron-left scaleX-n1-rtl icon-18px" />
              </button>
            </li>
            {pages.map((_, i) => (
              <li
                key={i}
                className={`mb-2 dt-paging-button page-item
               ${currentPage === i ? "active" : ""}`}
              >
                <button
                  onClick={() => goToPage(i)}
                  className={`btn btn-sm  mt-1 mx-1 ${currentPage === i ? "btn-primary" : "btn-label-primary"}`}
                  // className="btn btn-sm btn-primary mt-1 mx-1"
                  type="button"
                >
                  {i + 1}
                </button>
              </li>
            ))}
            <li className={`dt-paging-button page-item  ${!hasNextPage ? "disabled" : ""}`}>
              <button onClick={() => goToPage(currentPage + 1)} className="page-link next" role="link" type="button">
                <i className="icon-base ti tabler-chevron-right scaleX-n1-rtl icon-18px" />
              </button>
            </li>
            {/* <li className={`dt-paging-button page-item ${!hasNextPage ? "disabled" : ""}`}><button
                                                                 onClick={() => {
                                                                     if (hasNextPage) fetchNextPage().then(() => goToPage(currentPage + 1));
                                                                 }} className="page-link last" role="link" type="button" ><i className="icon-base ti tabler-chevrons-right scaleX-n1-rtl icon-18px" /></button></li> */}
            <li className={`dt-paging-button page-item ${!hasNextPage ? "disabled" : ""}`}>
              <button
                onClick={async () => {
                  if (!hasNextPage) return;

                  let targetPage = currentPage + 5; // jump 5 pages ahead
                  let fetchesNeeded = targetPage - (pages.length - 1);

                  // fetch missing pages (if required)
                  for (let i = 0; i < fetchesNeeded && hasNextPage; i++) {
                    await fetchNextPage();
                  }

                  // finally move to the target page (or last available if fewer)
                  const maxPageIndex = pages.length - 1;
                  setCurrentPage(Math.min(targetPage, maxPageIndex));
                }}
                className="page-link last"
                role="link"
                type="button"
              >
                <i className="icon-base ti tabler-chevrons-right scaleX-n1-rtl icon-18px" />
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default PaginationButtons;
